<style scoped>
  .container-div {overflow:auto;width:100%;height:70vh}
.container-div table {}
.container-div table th {top:0;position:sticky;background:#eee}
</style>

<template>
  <div class=" is-fullwidth">
   
    <div class="is-pulled-right"><select class="input" v-model="limit" >
      <option value="">Number of Orders</option>
      <option value="10">10 orders</option>  
      <option value="50">50 orders</option>  
      <option value="100">100 orders</option>  
      <option value="250">250 orders</option>  
      <option value="">Display All Orders</option>  
    </select></div>
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="is-pulled-right"><input class="input" type="date" v-model="end_date" /></div>
    
    <div class="is-pulled-right">
      <button @click="exportXLS()" class="button is-info mr-4" v-if="this.loading===false">Export to Excel</button>
    </div>

    <div class="buttons">
       <button class="button " :disabled="loading==true || working==true" v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
      
    </div>
    
    <div class="container-div">
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
    		<th>PO Number</th>
   	 		<th>Customer</th>
         
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Design Name</th>
          <th>Qty</th>
          <th>Received</th>
          <th>On Floor</th>
          <th>Off Floor</th>
        </tr>
    	</thead>
    	<tbody>
		    <tr v-if="this.loading === true">
                <td colspan="10" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="this.loading == false && orders.length == 0">
                <td colspan="10" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
        
               <td ><router-link :to="'/makeup/view-order?ponumber=' + order.ponumber">{{order.ponumber}}</router-link>
               <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="1==2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>
               </td>
          <td>{{order.clientname}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{ order.total_qty }}</td>
          <td>
            <span class="icon has-text-danger" v-if="order.received_started == 1 && order.received_finished == 0" @click="openModal('show-bundles', order.ponumber)">
                {{ order.qty_bundle_received }}
            </span>
              <span class="icon has-text-success has-text-weight-bold" v-if="order.received_finished == 1" @click="openModal('show-bundles', order.ponumber)">
                {{ order.qty_bundle_received }}
            </span>
          </td>
          <td>
            <span class="icon has-text-danger" v-if="order.on_factory_floor_started == 1 && order.on_factory_floor_finished == 0" @click="openModal('show-bundles', order.ponumber)">
                {{ order.qty_bundle_on_factory_floor }}
            </span>
              <span class="icon has-text-success has-text-weight-bold" v-if="order.on_factory_floor_finished == 1" @click="openModal('show-bundles', order.ponumber)">
                {{ order.qty_bundle_on_factory_floor }}
            </span>
          </td>
          <td>
           <span class="icon has-text-danger" v-if="order.off_factory_floor_started == 1 && order.off_factory_floor_finished == 0" @click="openModal('show-bundles', order.ponumber)">
            {{ order.qty_bundle_off_factory_floor }}
            </span>
              <span class="icon has-text-success has-text-weight-bold" v-if="order.off_factory_floor_finished == 1" @click="openModal('show-bundles', order.ponumber)">
                {{ order.qty_bundle_off_factory_floor }}
            </span>

          </td>
          
             
			</tr>
    	</tbody>
      
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ makeup_total_qty }}</td>
          <td>{{ makeup_total_qty_received }}</td>
          <td>{{ makeup_total_qty_on_factory_floor }}</td>
          <td>{{ makeup_total_qty_off_factory_floor }}</td>
        </tr>
      </tfoot>
    </table>

    
  </div>

  <p class="mt-6">
      <strong>Completion needed by {{ this.end_date }}</strong><br />
      Total garments assigned : {{ makeup_total_qty }}<br />
      Total garments outstanding : {{( makeup_total_qty - makeup_total_qty_off_factory_floor)}}<br />
      Garments Currently On Floor : {{( makeup_total_qty_on_factory_floor - makeup_total_qty_off_factory_floor)}}<br />
      Garments Waiting To Go On Floor : {{( makeup_total_qty - makeup_total_qty_on_factory_floor)}}<br />
    </p>

    

    <div id="show-bundles" class="modal">
      <div class="modal-background"></div>
      <div class="modal-card" >
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modalOrder.ponumber }} <span v-if="modalOrder.completed==1 || modalOrder.status == 'COMPLETED'">Order is Complete</span></p>
          <button class="delete" aria-label="close" @click="closeAllModals()"></button>
        </header>
        <section class="modal-card-body" v-if="modalOrderLoading===false">
          <table class="table is-fullwidth" v-if="modalOrder.bundles.length > 0">
              <thead>
                <th>ID</th>
                <th>Qty/Size</th>
                <th>Received</th>
                <th>On Floor</th>
                <th>Off Floor</th>
              </thead>

              <tbody>
                <tr v-for="row in modalOrder.bundles" :key="row.id">
                  <td>{{ row.id}}</td>  
                  <td>{{ row.qty}} x {{ row.size_name}}</td>
                    <td>
                      
                      <span v-if="row.received==1">{{ row.date_received }}</span>
                    </td>
                    <td>
                      <span v-if="row.on_factory_floor==1">{{ row.date_on_factory_floor }}</span>
                      
                    </td>
                    <td>
                      
                      <span v-if="row.off_factory_floor==1">{{ row.date_off_factory_floor }}</span>
                    </td>
                </tr>
              </tbody>
          </table>
        </section>
        
      </div>
    </div>

    <div id="show-order" class="modal">
      <div class="modal-background"></div>
      <div class="modal-card" >
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modalOrder.ponumber }} <span v-if="modalOrder.completed==1 || modalOrder.status == 'COMPLETED'">Order is Complete</span></p>
          <button class="delete" aria-label="close" @click="closeAllModals()"></button>
        </header>
        <section class="modal-card-body" v-if="modalOrderLoading===false">
          <img :src="'https://www.oneillsonline.com/images/historical/' + modalOrder.garmentimage" />
          
          <h4 class="title is-4">Order Details</h4>
          <table class="table">

            <tbody>
              <tr>
                <td>Design Name</td>
                <td class="has-text-weight-bold">{{ modalOrder.designname}}</td>
              </tr>
              <tr>
                <td>Garment Name</td>
                <td class="has-text-weight-bold">{{ modalOrder.garmentname}}</td>
              </tr>
            </tbody>
          </table>

          <h4 class="title is-4">Bundles</h4>

        </section>
        
      </div>
    </div>
    
    
    
  </div>
</template>



<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: '',
      modalOrderPONumber: '',
      modalOrder: {ponumber: '', bundles: []},
      modalOrderLoading: false,
      accessToken:'',
      end_date: ''
      
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getMakeupOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.end_date)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
        getEndDate() {
              
              var d = new Date();
              
              d.setDate(d.getDate() + 365);
              return d.toISOString().slice(0,10);
              
      },
    
    
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?makeup=1").then(
               response => this.locations = response 
            );
      },
      async getModalOrder() {
        this.modalOrderLoading=true
          OrderService.getOrderByPONumber(this.accessToken, this.modalOrderPONumber, "")
          .then(
            (orders => {
                if(orders.length > 0)
                {
                      this.$set(this, "modalOrder", orders[0]);
                }
              this.modalOrderLoading=false
            }).bind(this)
          );
      },
      exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Makeup Overview.xlsx')

	 },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.qty_bundle_off_factory_floor < u.total_qty ) 
            {
               //console.log(u)
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {

            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.trim().toLowerCase()))
          }

          return filteredOrders
       
     },
     makeup_total_qty: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     makeup_total_qty_received: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.qty_bundle_received;
        }, 0);

        return total;
     },
     makeup_total_qty_on_factory_floor: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.qty_bundle_on_factory_floor;
        }, 0);

        return total;
     },
     makeup_total_qty_off_factory_floor: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.qty_bundle_off_factory_floor;
        }, 0);

        return total;
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
        });
  },
 
  mounted() {
    if (localStorage.makeup_limit) {
      this.limit = localStorage.makeup_limit;
    }
    else{
      this.limit = ''
    }

    if (localStorage.makeup_location_id) {
      this.selected_location_id = localStorage.makeup_location_id;
    }
    else{
      this.selected_location_id = 1
    }

    if (localStorage.makeup_end_date) {
      this.end_date = localStorage.makeup_end_date;
    }
    else{
      this.end_date = this.getEndDate()
    }
      
  },
  watch: {
    'selected_location_id'() {
      
      localStorage.makeup_location_id = this.selected_location_id
      if(this.accessToken != "")
      {
        this.orders = []
        this.getOrders();
      }
      
    },
    'limit'() {
      localStorage.makeup_limit = this.limit
      if(this.accessToken != "")
      {
        this.orders = []
        this.getOrders();
      }
    }
    ,
    'end_date'() {
      localStorage.makeup_end_date = this.end_date
      if(this.accessToken != "")
      {
        this.orders = []
        this.getOrders();
      }
    }
    ,
    'modalOrderPONumber'() {
      this.modalOrder = {ponumber:'', bundles: []}
      this.getModalOrder();
    }
    ,
    
  }
}


</script>

